module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('img', {
    attrs: {
      "src": require("./assets/logo.png")
    }
  }), _vm._v(" "), _c('h1', [_vm._v("vue-dropdowns")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/mikerodham/vue-dropdowns"
    }
  }, [_vm._v("https://github.com/mikerodham/vue-dropdowns")]), _vm._v(" "), _c('p', [_vm._v("A prettier way to display select boxes")]), _vm._v(" "), _c('dropdown', {
    attrs: {
      "options": _vm.arrayOfObjects,
      "selected": _vm.selectedObject
    },
    on: {
      "updateOption": _vm.updateSelected
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-502b1a0e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 13
// module chunks = 0